export const Hr = () => <hr className="bg-neutral-200" />;
